<template>
  <div id="app" class="footer">
			<ul class="f1">
				<li><a href="http://www.hkcd.com.hk/about/aboutUs/aboutUs_hkweb.html">關於我們</a></li><span class="ss"> | </span>
				<li><a href="http://www.hkcd.com.hk/about/copyright/copyright_hkweb.html">版權聲明</a></li><span class="ss"> | </span>
				<li><a href="http://www.hkcd.com.hk/about/privacy/privacy_web.html">隱私政策</a></li><span class="ss"> | </span>
				<li><a href="http://www.hkcd.com.hk/about/pact/pact_web.html">用戶協議</a></li><span class="ss"></span>
			</ul>
			<ul class="f2">
				<li>Copyright © All Rights Reserved</li>
			</ul>
		</div>

</template>

<script>
  // import { redirect } from '@/js/util.js';

  export default {
    name: 'app',
    data () {
      return {
      }
    },
    components: {
      
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/list/components/footer/footer.vue